import { CashRegisterTable } from "@okeys/shared-utils"
import { AuthUser } from "aws-amplify/auth"

/**
 * Récupère la caisse enregistreuse à laquelle l'utilisateur actuel est connecté
 * @param currentUser - L'utilisateur actuel authentifié
 * @param cashRegisters - La liste des caisses enregistreuses
 * @returns La caisse enregistreuse associée à l'utilisateur ou null si aucune n'est trouvée
 */
export const getCurrentCashRegister = (
  currentUser: AuthUser | undefined,
  cashRegisters: CashRegisterTable[]
): CashRegisterTable | null => {
  if (!currentUser?.userId || !cashRegisters || cashRegisters.length === 0) {
    return null
  }

  // Chercher une caisse qui a cet utilisateur comme currentUserId
  const userCashRegister = cashRegisters.find(
    (cashRegister) => cashRegister.currentUserId === currentUser.userId
  )

  return userCashRegister || null
}
